var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailWhite = function SvgEmailWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(18646 -13657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M18.8,37.6A18.8,18.8,0,0,1,5.506,5.506,18.8,18.8,0,0,1,32.093,32.093,18.676,18.676,0,0,1,18.8,37.6Zm-3.261-17.32L8.873,26.7H28.511l-6.659-6.413c-.5.481-.922.885-1.121,1.082a2.829,2.829,0,0,1-2,.889,2.792,2.792,0,0,1-1.775-.661C16.8,21.47,16.286,20.989,15.539,20.279Zm13.877-7.187c-1.281,1.215-4.5,4.266-6.674,6.348l6.675,6.431Zm-21.347,0V25.778l6.588-6.347C12.709,17.57,10,14.955,8.069,13.089Zm.877-.857c3.783,3.658,8.366,8.067,8.833,8.456a1.428,1.428,0,0,0,2.014-.1l.05-.059c.794-.794,6.081-5.81,8.622-8.22l.085-.081Z",
    transform: "translate(-18646 13657)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-white.96f499ba.svg";
export { ForwardRef as ReactComponent };